import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "../redux/store";
import { BsCheckSquareFill, BsSquare } from "react-icons/bs";
import DateTime from "../components/DateTime";
import Button from "../components/Button";
import { toast } from "react-toastify";
import { get_generate_data } from "../redux/generateSlice";
import { AiOutlineCaretDown } from "react-icons/ai";
import ChartLine from "../components/ChartLine";
import { get_generate, get_machine } from "../utils/apis";
import Loader from "../components/Loader";
import { Oval } from "react-loader-spinner";

const Generate = () => {
  const [generate_list, setgenerate_list] = useState([]);
  const { branch_list, b_loading } = useSelector((state) => state.branch_list);
  const [param, setParam] = useState([]);
  const [machine, setMachine] = useState([]);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [current_tab, setCurrent_tab] = useState("");
  const user = localStorage.getItem("user");
  const userId = JSON.parse(user);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [machineList, setMachineList] = useState([]);
  const [id, setId] = useState("");

  const onGenerate = () => {
    if (param.length == 0) {
      toast.info("Please select parameters required");
      return;
    }
    if (machine.length == 0) {
      toast.info("Please select machine");
      return;
    }
    if (start.length == 0) {
      toast.info("Please select start date");
      return;
    }
    if (end.length == 0) {
      toast.info("Please select end date");
      return;
    }
    var body = new FormData();
    body.append("userid", userId);
    machine.forEach((v) => body.append("machineid[]", v));
    body.append("params", param.toString());
    body.append("start", start);
    body.append("end", end);
    get_generate(body, setLoading1).then((v) => {
      if (v.success) {
        setgenerate_list(v.list);
      }
    });
  };
  const getMachine = (id) => {
    const body = new FormData();
    body.append("uuid", id);
    get_machine(body, setLoading).then((v) => {
      if (v.success == 0) {
        setMachineList(v.data.reverse());
      } else {
        toast.error(v.message);
      }
    });
  };
  useEffect(() => {
    setCurrent_tab(branch_list[0]?.uuid);
    getMachine(branch_list[0]?.uuid);
  }, []);

  const data = [];
  for (let j = 0; j < generate_list.length; j++) {
    const data1 = [];
    for (let i = 0; i < generate_list[j]?.tempdata?.length; i++) {
      const element = {
        name: generate_list[j]?.tempdata[i]?.datetime,
        median: generate_list[j]?.tempmedian,
        temperature: generate_list[j]?.tempdata[i]?.temperature,
      };
      data1.push(element);
    }
    const data2 = [];
    for (let i = 0; i < generate_list[j]?.waferdata?.length; i++) {
      const element = {
        name: generate_list[j]?.waferdata[i]?.datetime,
        median: generate_list[j]?.wafermedian,
        count: generate_list[j]?.waferdata[i]?.count,
      };
      data2.push(element);
    }
    const data3 = [];
    for (let i = 0; i < generate_list[j].gasdata?.length; i++) {
      const element = {
        name: generate_list[j]?.gasdata[i]?.datetime,
        median: generate_list[j]?.gasmedian,
        flowrate: generate_list[j]?.gasdata[i]?.flowrate,
      };
      data3.push(element);
    }
    data.push({
      name: generate_list[j].uuid,
      tempdata: data1,
      tempmax: generate_list[j].tempmax,
      waferdata: data2,
      wafermax: generate_list[j].wafermax,
      gasdata: data3,
      gasmax: generate_list[j].gasmax,
    });
  }

  return (
    <div className="main-home-container ">
      <div className="bg p">
        <div className="title sky mb20">Parameters required</div>
        <div className="check-div-wrap ">
          <div className="check-div">
            <Check setValue={setParam} value={param} val={"temp"} />
            Temperature
          </div>
          <div className="check-div">
            <Check setValue={setParam} value={param} val={"wafer"} />
            Wafer Count
          </div>
          <div className="check-div">
            <Check setValue={setParam} value={param} val={"gas"} />
            Gasflow
          </div>
        </div>
        <div className="title sky mb20">Select branch(s)</div>
        <div className="check-div-wrap">
          {branch_list.map((v, i) => (
            <div
              className="check-div"
              key={i}
              onClick={() => {
                setCurrent_tab(v.uuid);
                getMachine(v?.uuid);
                setMachine([]);
              }}
            >
              {current_tab == v.uuid ? (
                <BsCheckSquareFill className="cursor sky" />
              ) : (
                <BsSquare className="cursor sky" />
              )}
              {v.name}
            </div>
          ))}
        </div>
        <div className="title sky mb20">Select machine(s)</div>
        <div className="check-div-wrap">
          {loading ? (
            <div className="df alc jcc">
              <Oval
                height={25}
                width={25}
                color="#f00"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#f00"
                strokeWidth={4}
                strokeWidthSecondary={4}
              />
            </div>
          ) : (
            machineList.map((v, i) => (
              <div className="check-div" key={i}>
                <Check setValue={setMachine} value={machine} val={v.id} />
                {v.id}
              </div>
            ))
          )}
        </div>
        <div className="title sky">Select Date & Time</div>
        <div className="check-div-wrap">
          <DateTime
            title={"Start Date & Time"}
            placeholder={"Start Date & Time"}
            onChange={(e) => {
              setStart(e.target.value);
              setEnd("");
            }}
            value={start}
          />
          <DateTime
            title={"End Date & Time"}
            placeholder={"End Date & Time"}
            onChange={(e) => setEnd(e.target.value)}
            value={end}
            min={start}
          />
        </div>
        <Button
          title={"Apply"}
          onClick={() => onGenerate()}
          loading={loading1}
        />
      </div>

      <div className="mt10">
        {loading1 ? (
          <Loader />
        ) : (
          <div className="">
            {data?.map((v, i) => (
              <div key={i} className={`${i + 1 == id && "lightblue"} bg mb10`}>
                <div
                  className="container"
                  onClick={() => setId(i + 1 == id ? "" : i + 1)}
                >
                  <div className="temp-heading"> {v?.name}</div>
                  <AiOutlineCaretDown size={20} />
                </div>
                {i + 1 == id && (
                  <div>
                    {param.includes("temp") && (
                      <div className="graph-title">Temperature</div>
                    )}
                    {param.includes("temp") &&
                      (v.tempdata.length != 0 ? (
                        <div className="mb10">
                          <ChartLine
                            data={v.tempdata}
                            dataKey="temperature"
                            max={Number(v.tempmax) + 20}
                          />
                          <div className="graph-value-wrap">
                            <div
                              className="title-value "
                              style={{ color: "darkgreen" }}
                            >
                              Mean :<span>{generate_list[i]?.tempmean}°C</span>
                            </div>
                            <div
                              className="title-value"
                              style={{ color: "darkblue" }}
                            >
                              Median :
                              <span>{generate_list[i]?.tempmedian}°C</span>
                            </div>
                            <div
                              className="title-value"
                              style={{ color: "purple" }}
                            >
                              Mode :<span>{generate_list[i]?.tempmode}°C</span>
                            </div>
                            <div
                              className="title-value"
                              style={{ color: "magenta" }}
                            >
                              Standard Deviation :
                              <span>{generate_list[i]?.tempsd}°C</span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="no-data ">No data</div>
                      ))}
                    {param.includes("wafer") && (
                      <div className="graph-title">Cones Count</div>
                    )}
                    {param.includes("wafer") &&
                      (v.waferdata.length != 0 ? (
                        <div className="mb10">
                          <ChartLine
                            data={v.waferdata}
                            dataKey="count"
                            max={Number(v.wafermax) + 20}
                          />
                          <div className="graph-value-wrap">
                            <div
                              className="title-value "
                              style={{ color: "darkgreen" }}
                            >
                              Mean :<span>{generate_list[i]?.wafermean}</span>
                            </div>
                            <div
                              className="title-value"
                              style={{ color: "darkblue" }}
                            >
                              Median :
                              <span>{generate_list[i]?.wafermedian}</span>
                            </div>
                            <div
                              className="title-value"
                              style={{ color: "purple" }}
                            >
                              Mode :<span>{generate_list[i]?.wafermode}</span>
                            </div>
                            <div
                              className="title-value"
                              style={{ color: "magenta" }}
                            >
                              Standard Deviation :
                              <span>{generate_list[i]?.wafersd}</span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="no-data ">No data</div>
                      ))}
                    {param.includes("gas") && (
                      <div className="graph-title">Gas Flow</div>
                    )}
                    {param.includes("gas") &&
                      (v.gasdata.length != 0 ? (
                        <div className="mb10">
                          <ChartLine
                            data={v.gasdata}
                            dataKey="flowrate"
                            max={Number(v.gasmax) + 20}
                            // min={200}
                          />
                          <div className="graph-value-wrap">
                            <div
                              className="title-value "
                              style={{ color: "darkgreen" }}
                            >
                              Mean :<span>{generate_list[i]?.gasmean}</span>
                            </div>
                            <div
                              className="title-value"
                              style={{ color: "darkblue" }}
                            >
                              Median :<span>{generate_list[i]?.gasmedian}</span>
                            </div>
                            <div
                              className="title-value"
                              style={{ color: "purple" }}
                            >
                              Mode :<span>{generate_list[i]?.gasmode}</span>
                            </div>
                            <div
                              className="title-value"
                              style={{ color: "magenta" }}
                            >
                              Standard Deviation :
                              <span>{generate_list[i]?.gassd}</span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="no-data ">No data</div>
                      ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const Check = ({ setValue, value, val }) => (
  <div
    onClick={() => {
      setValue((pre) =>
        pre.find((el, i) => el == val)
          ? pre.filter((el) => el != val)
          : [...pre, val]
      );
    }}
  >
    {value?.find((el, i) => el == val) ? (
      <BsCheckSquareFill className="cursor sky" />
    ) : (
      <BsSquare className="cursor sky" />
    )}
  </div>
);

export default Generate;
